@if (showFormFieldLabel) {
    <div class="d-flex flex-column gap-space-4">
        @if (allowMultiFileUpload) {
            <lib-label>
                <ng-container i18n="@@CommonAttachmentsLabel">Attachments</ng-container>
            </lib-label>
        } @else {
            <lib-label>
                <ng-container i18n="@@CommonAttachmentSingleLabel">Attachments</ng-container>
            </lib-label>
        }
            <lib-supporting-text>
                <ng-content  select="[supportingText]"></ng-content>
            </lib-supporting-text>
    </div>
}

@if (!hasFiles || allowMultiFileUpload) {
    @if (showDragAndDrop) {
        <div class="d-flex flex-column justify-content-center align-items-center upload-attachment-border upload-attachment-container">
            <input id="fileElem" #inputFormElement (clicked)="UploadFile(); $event.stopPropagation();" multiple="multiple" accept="{{acceptedFormatText}}">
            <label class="w-100 d-flex flex-column justify-content-center align-items-center" for="fileElem">
                <div class="pt-1 pb-1">
                    <lib-icon [icon]="Icon.Common.CloudUploadOutline"  class="base-100"></lib-icon>
                </div>
                @if (!isMobileOrTablet) {
                    @if (!allowMultiFileUpload) {
                        <p class="typography-caption-large base-100" i18n="@@UploadComponentAddFileLabel">Drag and drop your file</p>
                    } @else {
                        <p class="typography-caption-large base-100" i18n="@@UploadComponentAddFilesLabel">Drag and drop your file(s)</p>
                    }
                    <small class="pb-1" i18n="@@CommonOrText">or</small>
                }
                <ng-container *ngTemplateOutlet="uploadButton"></ng-container>
            </label>
        </div>
    } @else {
        <div>
            <ng-container *ngTemplateOutlet="uploadButton"></ng-container>
        </div>
    }
}

@if (hasFiles && showAttachmentDialogPreviewerTitle) {
    <p class="upload-attachment-section-header padding-top-16">{{attachmentDialogPreviewerTitle}}</p>
}

@if (!useNewStyle) {
    <div class="w-100 d-flex flex-row upload-attachment-preview-container gap-2 padding-top-16">
        <div *ngFor="let file of files; let index=index;"
            class="upload-attachment-preview-file-container d-flex flex-column"
            [ngClass]="{'scss-error-file-highlighted': file.size > maxAllowedFilesize}">
            <div [ngClass]="{'upload-attachment-preview-image-with-text': !IsFileImage(file), 'upload-attachment-preview-image-without-text': IsFileImage(file), 'd-flex':true, 'justify-content-center': true}">
                @if (IsFileOther(file)) {
                    <div class="d-flex align-items-center">
                        <lib-icon [icon]="Icon.Common.FileDescriptionOutline" [size]="IconSize.Large"></lib-icon>
                    </div>
                }
                @if (IsFileImage(file)) {
                    <div>
                        @if (filesSources[index]) {
                            <img class="h-100" [src]="filesSources[index]" style="object-fit: contain">
                        }
                    </div>
                }
                @if (IsFileAudio(file)) {
                    <div class="d-flex align-items-center">
                        <lib-icon [icon]="Icon.Common.AudioFileOutline" [size]="IconSize.Large"></lib-icon>
                    </div>
                }
                @if (IsFileVideo(file)) {
                    <div class="d-flex align-items-center">
                        <lib-icon [icon]="Icon.Common.VideoFileOutline" [size]="IconSize.Large"></lib-icon>
                    </div>
                }
                @if (IsFileArchive(file)) {
                    <div class="d-flex align-items-center">
                        <lib-icon [icon]="Icon.Common.FileArchived" [size]="IconSize.Large"></lib-icon>
                    </div>
                }
            </div>
            @if (!IsFileImage(file)) {
                <p class="upload-attachment-preview-file-container-text">
                    {{file.name}}
                </p>
            }
            <lib-button
                [qaTag]="'$$Library_UploadAttachment_PreviewFile_Remove_Button-' + index"
                class="upload-attachment-preview-file-remove-button"
                [prefixIcon]="Icon.Common.CloseCircleOutline"
                [iconOnly]="true"
                [kind]="ButtonKind.Tertiary"
                (clicked)="RemoveFileAtIndex(index)">
            </lib-button>
        </div>
    </div>
} @else {
    @for (file of files; let index=$index; track index) {
        <div class="padding-y-10 padding-x-16 border rounded d-flex justify-content-between align-items-center gap-2">
            <div class="d-flex align-items-center gap-space-8 text-truncate">
                @if (file | method: IsFileOther) {
                    <lib-icon [icon]="Icon.Common.FileDescriptionOutline" [size]="IconSize.Medium"></lib-icon>
                } @else if ((file | method: IsFileImage) && filesSources[index]) {
                    <lib-icon [icon]="Icon.Common.ImageOutline" [size]="IconSize.Medium"></lib-icon>
                } @else if (file | method: IsFileAudio) {
                    <lib-icon [icon]="Icon.Common.AudioFileOutline" [size]="IconSize.Medium"></lib-icon>
                } @else if (file | method: IsFileVideo) {
                    <lib-icon [icon]="Icon.Common.VideoFileOutline" [size]="IconSize.Medium"></lib-icon>
                } @else if (file | method: IsFileArchive) {
                    <lib-icon [icon]="Icon.Common.FileArchived" [size]="IconSize.Medium"></lib-icon>
                }
                <p class="typography-body-medium w-100 text-truncate">{{file.name}}</p>
            </div>
            <div class="d-flex align-items-center gap-space-8">
                <p class="typography-body-small">{{file.size | formatFilesize}}</p>
                <lib-icon-button
                    qaTag="upload-component-remove-file-button"
                    [kind]="ButtonKind.NeutralTertiary"
                    [icon]="Icon.Common.Close"
                    [size]="ButtonSize.Small"
                    (clicked)="RemoveFileAtIndex(index)">

                </lib-icon-button>
            </div>
        </div>
    }
}



<ng-template #uploadButton>
    <lib-button class="pb-2"
        qaTag="upload-component-upload-button"
        [kind]="ButtonKind.Primary"
        [size]="ButtonSize.Small"
        [prefixIcon]="Icon.Common.Upload"
        [disabled]="disableUploadButton"
        (clicked)="UploadFile()">
        @if (allowMultiFileUpload) {
            <ng-container label i18n="@@UploadComponentChooseFilesLabel">Choose file(s)</ng-container>
        } @else {
            <ng-container label i18n="@@UploadComponentChooseFileLabel">Choose a file</ng-container>
        }
    </lib-button>
</ng-template>

@if (control && !hideInlineErrors) {
    <lib-error
        [control]="control"
        [errors]="errors">
    </lib-error>
}